/**
 * @file This file defines the row menu for the asset table.
 * It includes actions for editing an asset, opening it in ACC, and finding it in other services like Google Drive, Cintoo, and Empolis.
 */

// Row menu definitions for asset tables

// Helper function to remove b. prefix from project id
function removeBPrefix(str) {
    return str.replace(/^b\./, '');
}

/**
 * Creates the row menu for the asset table.
 * @param {string} selectedProjectId - The ID of the selected project.
 * @param {function} setEditableRowIndex - A function to set the index of the row that is being edited.
 * @returns {Array} An array of objects that define the row menu items.
 */
export const createRowMenu = (selectedProjectId, setEditableRowIndex) => [
    // TODO edit should be only possible when handleRowClick is finished
    {
        label: "Edit Asset",
        action: function (e, row) {
            setEditableRowIndex(row.getIndex());
            // setIsEditable(true);
            console.log('Row index set to editable:', row.getIndex());
        }
    },
    {
        label: "Open in ACC",
        action: (e, row) => {
            e.preventDefault();
            window.open(`https://acc.autodesk.eu/build/assets/projects/${removeBPrefix(selectedProjectId)}/assets?assetId=${row.getData().id}`);
        }
    },
    {
        label: "Find in Google Drive",
        action: (e, row) => {
            e.preventDefault();
            window.open(`https://drive.google.com/drive/search?q=${encodeURIComponent(row.getData().clientAssetId)}`);
        }
    },
    // TODO: have project id somewhere in the settings on server side
    {
        label: "Open in Cintoo DEMO",
        action: (e, row) => {
            e.preventDefault();
            window.open(`https://aec.cintoo.com/projects/bim/cHJvamVjdC02Nzk5/threedview?q=type:tag%20label:${row.getData().clientAssetId}`);
        }
    },
    {
        label: "Open in UNITEC DEMO",
        action: (e, row) => {
            e.preventDefault();
            window.open(`https://aec.cintoo.com/projects/bim/cHJvamVjdC0xNzc4NTM/threedview?q=type:tag%20label:${row.getData().clientAssetId}`);
        }
    },
    // TODO store empolis project id in the settings on server side
    {
        label: "Find in Empolis",
        action: (e, row) => {
            e.preventDefault();
            window.open(`https://esc-eu-central-1.empolisservices.com/service-express/portal/project1_p/search?useExpertQuery=0&text=${encodeURIComponent(row.getData().clientAssetId)}`);
        }
    }
];